import { useState } from 'react';
import { View, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { theme } from '@socrait/react';

import { TableRow } from './TableRow';
import { TableCell } from './TableCell';
import { ColumnConfig } from './types';

export interface TableBodyProps<T> {
  data: T[];
  columns: ColumnConfig<T>[];
  columnGap?: number;
  rowStyle?: StyleProp<ViewStyle>;
  rowHeight?: number;
  borderBottomColor?: string;
  keyExtractor?: (item: T, index: number) => string;
}

export function TableBody<T>({
  data,
  columns,
  columnGap,
  rowStyle,
  rowHeight,
  borderBottomColor,
  keyExtractor,
}: TableBodyProps<T>) {
  const [hoveredRowIndex, setHoveredRowIndex] = useState<number | null>(null);

  return (
    <View style={styles.bodyContainer}>
      {data.map((item, rowIndex) => {
        const isHovered = hoveredRowIndex === rowIndex;
        const key = keyExtractor ? keyExtractor(item, rowIndex) : `row-${rowIndex}`;

        return (
          <TableRow
            key={key}
            columnGap={columnGap}
            style={rowStyle}
            height={rowHeight}
            onHoverChange={(hovered) => setHoveredRowIndex(hovered ? rowIndex : null)}>
            {columns.map((column, colIndex) => (
              <TableCell
                key={colIndex}
                width={column.width}
                align={column.align}
                noBorder={column.noBorder}
                borderBottomColor={borderBottomColor}
                style={column.cellStyle}>
                {column.render?.(item, rowIndex, isHovered)}
              </TableCell>
            ))}
          </TableRow>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  bodyContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.medium,
  },
});
